module.exports = __webpack_public_path__ + "9cc04cede20314e9d85fea43ffc44510.jpg";